import { render, staticRenderFns } from "./VinAccount.vue?vue&type=template&id=2a811a3a&scoped=true&"
import script from "./VinAccount.vue?vue&type=script&lang=js&"
export * from "./VinAccount.vue?vue&type=script&lang=js&"
import style0 from "./VinAccount.vue?vue&type=style&index=0&id=2a811a3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a811a3a",
  null
  
)

export default component.exports